import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import ModalCamposObligatorios from '../../../App/ModalCamposObligatorios'
import { Paper, Typography } from '@mui/material';
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
function TablaResponsablesInstalaciones(props) {

    const modoVerDetalle = useSelector(store => store.FC_36SolicitudAtencionACliente.modoVerDetalle)

    const { api = undefined } = props
    const { handdleEditPrev } = api
    let rows = props.rows

    let columns = [
        {
            field: 'tipoinstalacion', headerName: 'Instalación', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) => (
                <div>
                    <div style={{
                        height: '20px', width: '20px'
                    }}><Tooltip title={`${params.row.relacioncontacto !== null ?
                        params.row.alta === false ? (params.row.baja === false && params.row.isbaja === false) ? 'El color gris son anexos del cliente no modificados' :
                            'El color rojo es para un anexo ya registrado que va a dar de baja' :
                            'El color amarillo es para un anexo que fue dado de baja y se requiere dar de alta nuevamente'
                        : 'El color verde es un anexo nuevo para dar de alta en esta solicitud'}`}
                        arrow style={{ marginTop: '-5%' }}>
                            <label>{`${params.row.relacioncontacto !== null ?
                                params.row.alta === false ? (params.row.baja === false && params.row.isbaja === false) ? 'El color gris son anexos del cliente no modificados' :
                                    'Baja' : 'Alta nuevamente' : 'Alta'}`}</label>
                        </Tooltip></div>
                    <Tooltip title={`${params.row.tipoinstalacion}`} arrow>
                        <label>{`${params.row.tipoinstalacion} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'alias', headerName: 'Alias de la instalacion', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.alias}:${params.row.domicilio}`} arrow>
                        <label>{`${params.row.alias}: ${params.row.domicilio} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'responsableinstalacion', headerName: 'Responsable de instalación', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 250,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.responsableinstalacion}`} arrow>
                        <label>{`${params.row.responsableinstalacion} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'telefono', headerName: 'Teléfono', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 130,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.telefono}`} arrow>
                        <label>{`${params.row.telefono} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'correoelectronico', headerName: 'Correo Electrónico', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 280,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.correoelectronico}`} arrow>
                        <label>{`${params.row.correoelectronico} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 190,
            renderCell: (params) => (
                !params.row.baja &&
                <Fragment>
                    <button className={params.row.correcto ? ('btn btn-success ms-1') : ('btn btn-outline-success ms-1')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                    <button className={params.row.incorrecto ? ('btn btn-danger ms-2') : ('btn btn-outline-danger ms-2')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                </Fragment>
            )
        },
    ]

    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')
    const [vigencia, setVigencia] = React.useState(false);
    const botonVigencia = () => {
        setVigencia(true)
    }
    const botonCerrarVigencia = () => {
        obtenerVigencia()
        setVigencia(false)
    }
    const handleOpenModalCorrecto = (params) => {
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.Campo)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
    }
    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
    }
    const modalComponentCorrecto = () => {
        return (
            <Modal
                open={openModalCorrecto}
                onClose={handleCloseModalCorrecto}
                hideBackdrop={true} >
                <Box sx={styleCorrecto}>
                    <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                        <div className="form-floating mb-3" color='black'>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={valor} onChange={e => setValor(e.target.value)} />
                            {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                            <label htmlFor="floatingInput">Campo</label>
                        </div>
                        <div className="form-floating mb-3">
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                            <label htmlFor="floatingInput">Observaciones</label>
                        </div>
                        <br /><br />
                    </Typography> <br />
                    {modoVerDetalle ?
                        <div className='row'>
                            <div className={` text-center`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CERRAR</button>
                            </div>
                        </div>
                        :
                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                            </div>
                        </div>
                    }
                </Box>
            </Modal>
        )
    }
    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalIncorrecto}
                    onClose={handleCloseModalIncorrecto}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleIncorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            <label className='text-center'>Observaciones</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                        </Typography>
                        <br />

                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-6'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonGuardar = () => {
        let datos = { id: id, campo: campo, correcto: correcto, incorrecto: incorrecto, observaciones: observaciones, valor: valor }
        handdleEditPrev(datos)
        handleCloseModalCorrecto(true)
        handleCloseModalIncorrecto(true)
    }
    return (
        <div className='row justify-content-center'>
            <div className='col-12'><br />
                <div style={{ height: (130 + (rows?.length * 50)), width: '87%', color: 'black', marginLeft: '10%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            '& .MuiDataGrid-cell': {
                                display: 'block',
                                position: 'relative',
                                textAlign: 'center',
                            },
                        }}
                    />

                </div><br />
            </div>
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
        </div>
    )

}
export default TablaResponsablesInstalaciones